import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile())?_c('div',{staticClass:"loading_screen"},[_c('img',{attrs:{"src":"/assets/loader_screen.gif","alt":"Loading"}})]):_c('div',{staticClass:"loading_screen"},[_c(VProgressCircular,{attrs:{"rotate":360,"size":100,"width":15,"model-value":_vm.value,"color":"teal"}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }